import { Head, Link } from "@inertiajs/react"
import { PageLayout } from "@/components/VocationalTest/PageLayout"
import { Card } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { XCircle, ArrowLeft } from "lucide-react"

export default function CheckoutCancel() {
  return (
    <>
      <Head title="Pagamento Cancelado" />
      <PageLayout>
        <div className="w-full max-w-md">
          <Card className="w-full p-8 md:p-12 shadow-elegant text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted mb-6">
              <XCircle className="w-8 h-8 text-muted-foreground" />
            </div>

            <h1 className="text-2xl font-bold mb-3">Pagamento Cancelado</h1>

            <p className="text-muted-foreground mb-8">
              O pagamento foi cancelado. Você pode voltar e tentar novamente quando quiser.
            </p>

            <div className="space-y-3">
              <Button asChild className="w-full">
                <Link href="/checkout">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Voltar ao Checkout
                </Link>
              </Button>

              <Button asChild variant="ghost" className="w-full">
                <Link href="/results">
                  Ver meu resultado gratuito
                </Link>
              </Button>
            </div>
          </Card>
        </div>
      </PageLayout>
    </>
  )
}
